import { ZtInfo } from "@/api";
import dayjs from "dayjs";
export enum FORMAT {
  DEFAULT = "YYYY-MM-DD",
  INVOICE = "YYYY-MM",
  FINANCE_MONTH = "YYYY年M月份",
  FINANCE_QUARTER = "YYYY年M季度",
  FINANCE_All = "YYYY年MM月DD日",
}

export const formatTime = (date: number | Date | string, format: string = FORMAT.DEFAULT) => {
  if (typeof date == "string") date = new Date(date);
  if (format == FORMAT.FINANCE_QUARTER) {
    const year = dayjs(+date).format("YYYY");
    const quarter = Math.ceil(Number(dayjs(+date).format("M")) / 3);
    return `${year}年${quarter}季度`;
  } else return dayjs(+date).format(format);
};

export enum DATE {
  MAX = "max",
  MIN = "min",
  CURRENT = "current",
}

/** 获取时间 */
export const getDate = (obj: ZtInfo, type: DATE) => {
  let date = new Date();
  if (type == DATE.MIN) {
    date = new Date(obj.startYear, obj.startPeriod - 1, 1);
  } else if (type == DATE.MAX) {
    // 年月可以选到当前自然月。原来卡的是账套最高结账期间（topBalanceDate / topPeriod），
    // 账套没结账到当月时就选不到当月，看不了最近的发票
    date = new Date(date.getFullYear(), date.getMonth(), 1);
  } else if (type == DATE.CURRENT) {
    date = new Date(obj.currentYear, obj.currentPeriod - 1, 1);
  }
  return isNaN(+date) ? new Date() : date;
};
